import { render, staticRenderFns } from "./Guide.vue?vue&type=template&id=529604dc&scoped=true"
import script from "./Guide.vue?vue&type=script&setup=true&lang=js"
export * from "./Guide.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Guide.vue?vue&type=style&index=0&id=529604dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529604dc",
  null
  
)

export default component.exports